module Environments {
    module.directive("agentWarningTemplate", function () {
        return {
            templateUrl: "AgentWarningTemplate"
        };
    });
}